const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: false,
      showAnimationDuration: 500,
      scaleMode: 'zoom',

      gallery: this,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,
      closeOnVerticalDrag: true,
      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
      this.addDots()
      this.addNextPrev()
    })

    this._pswpKeyHandler = (event) => {
      const pswp = this.photoSwipeInstance.pswp
      if (!pswp || !pswp.currSlide) return

      if (event.key === '+') {
        const scale = Math.min(
          pswp.currSlide.currZoomLevel + 0.25,
          pswp.currSlide.zoomLevels.max,
        )
        pswp.zoomTo(
          scale,
          { x: pswp.viewportSize.x / 2, y: pswp.viewportSize.y / 2 },
          300,
        )
      }

      if (event.key === '-') {
        const scale = Math.max(
          pswp.currSlide.currZoomLevel - 0.25,
          pswp.currSlide.zoomLevels.min,
        )
        pswp.zoomTo(
          scale,
          { x: pswp.viewportSize.x / 2, y: pswp.viewportSize.y / 2 },
          300,
        )
      }
    }

    this.photoSwipeInstance.on('afterInit', () => {
      document.addEventListener('keydown', this._pswpKeyHandler)
    })

    this.photoSwipeInstance.on('destroy', () => {
      document.removeEventListener('keydown', this._pswpKeyHandler)
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close image gallery zoom',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addDots () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Dots',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const dotEls = []
        let thumbEl
        let dotEl
        let previousIndex = -1

        for (let i = 0; i < pswp.getNumItems(); i++) {
          dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Dot'
          dotEl.setAttribute('aria-label', `Go to slide ${i + 1}`)
          dotEl.onclick = (event) => {
            pswp.goTo(dotEls.indexOf(event.target))
          }

          thumbEl = document.createElement('img')
          thumbEl.className = 'pswp-Action_DotImage'
          thumbEl.src = this.els.link.elements[i].dataset.thumbImage

          dotEl.appendChild(thumbEl)
          element.appendChild(dotEl)

          dotEls.push(dotEl)
        }

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          dotEls[pswp.currIndex].setAttribute('aria-current', 'true')
          previousIndex = pswp.currIndex
        })
      },
    })
  }

  addNextPrev () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'paging',
      className: 'pswp-Action_Buttons',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const prevEl = document.createElement('button')
        prevEl.type = 'button'
        prevEl.className = 'pswp-Action_Button'
        prevEl.innerHTML = this.prevSvg
        prevEl.setAttribute('aria-label', 'Go to previous image')
        prevEl.onclick = () => {
          pswp.goTo(pswp.currIndex - 1)
        }

        const nextEl = document.createElement('button')
        nextEl.type = 'button'
        nextEl.className = 'pswp-Action_Button'
        nextEl.innerHTML = this.nextSvg
        nextEl.setAttribute('aria-label', 'Go to next image')
        nextEl.onclick = () => {
          pswp.goTo(pswp.currIndex + 1)
        }

        element.appendChild(prevEl)
        element.appendChild(nextEl)

        pswp.on('change', () => {
          prevEl.setAttribute('aria-hidden', pswp.currIndex === 0)
          nextEl.setAttribute(
            'aria-hidden',
            pswp.currIndex + 1 === pswp.getNumItems(),
          )
        })
      },
    })
  }

  get prevSvg () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
        <path fill="currentColor" d="m11.47 15.53-5-5a.75.75 0 0 1 0-1.06l5-5 1.06 1.06L8.06 10l4.47 4.47-1.06 1.06Z"/>
      </svg>
    `
  }

  get nextSvg () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
        <path fill="currentColor" d="m8.53 4.47 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06L11.94 10 7.47 5.53l1.06-1.06Z"/>
      </svg>
    `
  }

  get closeSvg () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
        <path stroke="currentColor" stroke-width="1.5" d="m5.758 5.758 8.485 8.485M5.758 14.242l8.485-8.485"/>
      </svg>
    `
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
